export default __webpack_public_path__ + "static/media/tooltip_blue_i.20e53af2.svg";